import { useState, useMemo } from 'react'
import { Search } from 'lucide-react'
import { CATEGORIES } from 'shared'
import { cn } from '@/lib/utils'

type CategorySelectProps = {
  value: string
  onChange: (category: string) => void
}

const optionClass = (selected: boolean) =>
  cn(
    'text-left px-4 py-3 rounded-xl border text-sm font-medium transition-colors',
    selected
      ? 'border-primary bg-primary/10 text-foreground'
      : 'border-border bg-card text-foreground hover:border-foreground/30'
  )

export default function CategorySelect({ value, onChange }: CategorySelectProps) {
  const [search, setSearch] = useState('')

  const filtered = useMemo(() => {
    if (!search) return CATEGORIES
    const q = search.toLowerCase()
    return CATEGORIES.filter((c) => c.label.toLowerCase().includes(q) || c.value.includes(q))
  }, [search])

  return (
    <div className="space-y-4">
      <div className="relative">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 size-5 text-muted-foreground" />
        <input
          type="text"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search categories..."
          className="w-full pl-10 pr-4 py-3 rounded-xl border border-input bg-card text-foreground placeholder:text-muted-foreground outline-none transition-colors focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50"
        />
      </div>

      <div className="grid grid-cols-2 gap-2 max-h-64 overflow-y-auto pr-1">
        {filtered.map((cat) => (
          <button
            key={cat.value}
            type="button"
            onClick={() => onChange(cat.value)}
            className={optionClass(value === cat.value)}
          >
            {cat.label}
          </button>
        ))}
      </div>
    </div>
  )
}
